/* React imports */
import React, { lazy, Suspense } from "react";

/* External imports */
import { BrowserRouter, Route, Switch } from "react-router-dom";

/* Internal imports */
import { ScrollToTop } from "./shared/ScrollToTop/scroll-to-top";

/* Style imports */
import "./App.scss";
import "normalize.css";

/* Lazy loads */
const CMSApp = lazy(() => import("./cms-interface"));
const UIGuide = lazy(() => import("./UiGuide"));
const UserApp = lazy(() => import("./user-interface"));

const App = () => {
  /* Component */
  return (
    <div className="cicero">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div className="fallback" />}>
          <Switch>
            <Route path="/cms">
              <CMSApp />
            </Route>
            <Route exact path="/ui-guide">
              <UIGuide />
            </Route>
            <Route path="/:tenantId/:locationId">
              <UserApp />
            </Route>
          </Switch>
        </Suspense>
      </BrowserRouter>
    </div>
  );
};

export default App;
